import { Eyebrow, Reveal } from "@/components/Reveal";
import { CONTACT } from "@/lib/content";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    updated: "Ford & Associates — Newmarket, Ontario",
    body: [
      "Ford & Associates respects your privacy and is committed to protecting the personal information you share with us. This website collects only the information you choose to provide through our contact form — your name, email address, telephone number, company name (if applicable), the service you are interested in, and your message.",
      "Contact form submissions are used solely to respond to your enquiry. They are retained by the firm only as long as necessary and are never sold or shared with third parties for marketing purposes.",
      "This public website does not collect tax documents, social insurance numbers or account credentials. Secure document exchange and portal sign-in occur only within our separate, dedicated client applications (Client Manager and Tax Manager), each on its own secure domain.",
      "The website uses standard, privacy-respecting analytics to understand overall usage. Links to the Canada Revenue Agency and other Government of Canada resources open on official canada.ca pages, which are governed by their own privacy policies.",
      "You may request access to, correction of, or deletion of your personal information held by the firm by contacting us at info@fordassociates.ca or 289-464-1001.",
    ],
  },
  terms: {
    title: "Terms of Use",
    updated: "Ford & Associates — Newmarket, Ontario",
    body: [
      "The content of this website is provided for general information about Ford & Associates and its accounting, taxation and advisory services. It does not constitute accounting, tax or legal advice, and no client relationship is created by using this website.",
      "Tax rules and deadlines change. While we aim to keep the information here current, you should consult with the firm directly before acting on any general information published on this site.",
      "Links to the Canada Revenue Agency, Government of Canada resources and third-party client applications (Client Manager, Tax Manager) are provided for convenience. We are not responsible for the content or availability of external websites.",
      "All content on this website — including text, design and branding — is the property of Ford & Associates unless otherwise stated.",
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <div className="bg-[#FFFFFF] pt-[72px]" data-testid={`legal-${kind}-page`}>
      <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-24">
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-4 font-display text-5xl font-medium tracking-tight text-[#102036]">{c.title}</h1>
        <p className="mt-3 text-[12px] font-bold uppercase tracking-[0.2em] text-[#4A5568]/70">{c.updated}</p>
        <div className="mt-10 space-y-5 border-t border-[#102036]/10 pt-8">
          {c.body.map((p, i) => (
            <p key={i} className="text-[16px] leading-relaxed text-[#102036]/80">{p}</p>
          ))}
        </div>
        <p className="mt-10 text-sm text-[#4A5568]">
          Questions? {CONTACT.phoneDisplay} · <a href={`mailto:${CONTACT.email}`} className="font-semibold text-[#102036]">{CONTACT.email}</a>
        </p>
      </div>
    </div>
  );
}
